import { useQuery } from '@tanstack/react-query'
import { API } from '../api/api'
import { queryKeys } from '../api/queryKeys'
import type { LoadControllerGetAggregatedMonthlyBaseloadsData } from '../api/types/generated-types'
import { ONE_MINUTE_IN_MS } from '../utils/constants'

export const useAggregatedMonthlyBaseloads = (data: LoadControllerGetAggregatedMonthlyBaseloadsData, options?: { enabled?: boolean }) => {
  const queryKey = queryKeys.load.aggregatedMonthlyBaseloads.byParams.toKeyWithArgs(data)
  const hasHierarchySelection = !!(data.locationId || data.buildingId || data.regionId || data.companyId)

  const query = useQuery({
    queryKey,
    enabled: (options?.enabled ?? true) && hasHierarchySelection,
    staleTime: ONE_MINUTE_IN_MS * 5,
    queryFn: async () => {
      const response = await API.load.getAggregatedMonthlyBaseloads(data as any)
      return response.monthlyData
    },
  })

  return query
}
